<template>
  <v-card>
    <v-card-text>
      <v-form ref="form" lazy-validation>
        <p>Please select your intended major.</p>
        <v-select v-model="major" :items="majors" :rules="[v => !!v || 'Major is Required']" label="Intended Major" outlined />
        <v-checkbox v-model="declareSecondMajor" label="I would like to pursue a double major (this is optional)" />
        <v-select v-if="declareSecondMajor" v-model="secondMajor" :items="majors" :rules="[v => !!v || !declareSecondMajor || 'Required when pursuing a double major is selected']" label="Second Major" outlined />
        <v-checkbox v-model="declareMinor" label="I would like to add a minor (optional; can also be done later if you decide to)" />
        <v-select v-if="declareMinor" v-model="minor" :items="minors" :rules="[v => !!v || !declareMinor || 'Required when adding a minor is selected']" label="Minor" outlined />
        <v-divider class="mb-2 mt-1" />
        <v-alert type="info">Placement Tests are all online and must be completed prior to submitting your pre-registration form.</v-alert>
      </v-form>
    </v-card-text>
    <v-card-actions>
      <v-btn color="primary" @click="next()">Continue</v-btn>
    </v-card-actions>
  </v-card>
</template>
<script>
import { ref, onMounted, computed, watch } from '@vue/composition-api'
export default {
  props: {
    data: {
      type: Object,
      required: true
    }
  },
  setup (props, { root, emit }) {
    const form = ref(null)
    const term = computed(() => root.$store.state.term)

    const majors = ref([])
    const minors = ref([])

    onMounted(async () => {
      if ('major' in props.data) major.value = props.data.major
      if ('secondMajor' in props.data) secondMajor.value = props.data.secondMajor
      if ('minor' in props.data) minor.value = props.data.minor
    })
    watch(term, async () => {
      const { data } = await root.$feathers.service('student/reg-setting').find({ query: { form: 'prereg', term: root.$store.state.term, category: { $in: ['major', 'minor'] } } })
      for (const { category, options } of data) {
        if (category === 'major') majors.value = options
        else if (category === 'minor') minors.value = options
      }
    })

    const major = ref('')
    const secondMajor = ref('')
    const minor = ref('')

    const declareSecondMajor = ref(false)
    const declareMinor = ref(false)

    function next () {
      if (form.value.validate()) {
        let obj = { major: major.value }
        if (declareSecondMajor.value) obj.secondMajor = secondMajor.value
        if (declareMinor.value) obj.minor = minor.value
        emit('next', obj)
      }
    }

    return {
      form,
      majors,
      minors,
      major,
      secondMajor,
      minor,
      declareSecondMajor,
      declareMinor,
      next
    }
  }
}
</script>
